<template>
  <div>
    <custom-modal
      :title="'Daty na kiedy zlecenie zostało zamówione'"
      :id="'orderDaysModal'"
    >
      <template #content>
        <div class="modal-body" v-if="order">
          <table class="table">
            <thead>
              <tr class="tr-table">
                <th scope="col">Data</th>
                <th scope="col">Status</th>
                <th scope="col">Zmień</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="day in orderDaysParsed" :key="day.id">
                <td>{{ formattedDateWithoutTime(day.date) }}</td>
                <td>
                  {{
                    day.status === "CONFIRMED"
                      ? "Zatwierdzona"
                      : day.status === "DELETED"
                      ? "Usunięta przez opiekuna"
                      : day.status === "ADDED"
                      ? "Zaproponowana przez opiekuna, oczekuje na zatwierdzenie"
                      : ""
                  }}
                </td>
                <td>
                  <button
                    type="button"
                    class="btn btn-outline-dark"
                    @click="showDatePickerForOrderDay(day)"
                  >
                    Zmień
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
          <div v-if="orderDayDatePickerVisible" class="order-day-change">
            Zmiana daty
            {{ formattedDateWithoutTime(selectedOrderDayToChange.date) }}
            <datepicker
              :monday-first="true"
              :language="pl"
              v-model="newOrderDay"
              name="newOrderDay"
              :placeholder="'Nowa data'"
            ></datepicker>
            <button
              type="button"
              class="btn btn-outline-dark"
              @click="saveNewOrderDay"
            >
              Zapisz
            </button>
          </div>
        </div>
      </template>
    </custom-modal>
    <button
      style="visibility: hidden"
      id="orderDaysModal-open"
      type="button"
      data-toggle="modal"
      data-target="#orderDaysModal"
    />
  </div>
</template>

<script>
import shared from "../shared";
import CustomModal from "./CustomModal.vue";
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import axios from "../axios";
import { pl } from "vuejs-datepicker/dist/locale";
export default {
  props: {
    order: {
      type: Object,
      required: false,
    },
  },
  emits: ["orderDayChanged"],
  components: { CustomModal, Datepicker },
  name: "OrderDaysModal",
  data() {
    return {
      pl,
      loading: false,
      orderDayDatePickerVisible: false,
      selectedOrderDayToChange: "",
      newOrderDay: "",
      orderDaysParsed: [],
    };
  },
  watch: {
    order: {
      immediate: true,
      handler(newOrder) {
        this.orderDaysParsed = this.parseOrderDays(newOrder?.order_days || []);
      },
    },
  },
  async created() {
    this.formattedDateWithoutTime = shared.formattedDateWithoutTime;
  },

  methods: {
    parseOrderDays(orderDays) {
      const daysArray = [];
      if (typeof orderDays !== "string") {
        return orderDays
          .slice()
          .sort((a, b) => new Date(a.date) - new Date(b.date));
      }

      const ordersDaysSorted = orderDays.split(",");

      for (const order of ordersDaysSorted) {
        const [orderId, dateTime, status] = order.split(";");

        daysArray.push({
          date: dateTime,
          id: orderId,
          status: status,
        });
      }
      return daysArray.sort((a, b) => new Date(a.date) - new Date(b.date));
    },

    closeModal() {
      document.getElementById("orderDaysModal-close").click();
      this.orderDayDatePickerVisible = false;
      this.selectedOrderDayToChange = "";
      this.newOrderDay = "";
    },

    showDatePickerForOrderDay(day) {
      this.orderDayDatePickerVisible = true;
      this.selectedOrderDayToChange = day;
    },
    async saveNewOrderDay() {
      try {
        await axios.put(`/api/admin/changeOrderDay`, {
          order_day_id: this.selectedOrderDayToChange.id,
          order_day: moment(this.newOrderDay).format("YYYY-MM-DD 17:00:00.000"),
        });
        this.selectedOrderDayToChange = "";
        this.newOrderDay = "";
        this.orderDayDatePickerVisible = false;
        this.closeModal();
        this.$emit("orderDayChanged");

        this.$notify({
          group: "success",
          text: "Pomyślnie edytowano termin zamówienia",
        });
      } catch (error) {
        let errorMessage = "Spróbuj ponownie";
        console.log(error.response.data.error);
        if (error.response.data.error === "day_already_added") {
          errorMessage = "Podany dzień jest już dodany";
        }
        if (error.response.data.error === "wrong_date") {
          errorMessage = "Data nie może być z przeszłości";
        }

        this.$notify({
          group: "error",
          text: errorMessage,
        });
      }
    },
  },
};
</script>

<style scoped>
.modal-body {
  font-size: 14px;
  padding: 10px;
}
div {
  padding: 0;
}
.order-day-change {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
</style>